// Generate ID for elements for better identification
export const generateVisualElementId = (label: string) => {
  if (!label) {
    return `glp-element`;
  }
  const id = label.toLowerCase().replace(' ', '-');
  return `${id}`;
};

export const uniqBy = <T, K extends keyof T>(
  arr: T[],
  predicate: ((item: T) => any) | K
) => {
  const cb =
    typeof predicate === 'function' ? predicate : (item: T) => item[predicate];

  const result: T[] = [];
  const map = new Map<any, T>();

  arr.forEach((item) => {
    const key = item === null || item === undefined ? item : cb(item);

    if (!map.has(key)) {
      map.set(key, item);
      result.push(item);
    }
  });

  return result;
};

export function getTodayDate() {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

// create options params that will be passed
export function formatDateTime(
  date: string,
  options: Intl.DateTimeFormatOptions = {
    dateStyle: 'medium',
    timeStyle: undefined // Default: no time unless specified
  }
) {
  const dateObj = new Date(date);

  return dateObj.toLocaleDateString('en-US', options);
}

// Function to convert hex to HSL
export const hexToHsl = (hexColor: string): string => {
  // Remove the # if present
  const hex = hexColor.replace('#', '');

  // Parse the hex values
  const r = parseInt(hex.substr(0, 2), 16) / 255;
  const g = parseInt(hex.substr(2, 2), 16) / 255;
  const b = parseInt(hex.substr(4, 2), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(
    l * 100
  )}%`;
};

export const updateCSSVariable = (property: string, value: string) => {
  const root = document.documentElement;
  const hslValue = hexToHsl(value);
  root.style.setProperty(property, hslValue);
};
